import MojitoPresentation from 'mojito/presentation';

const { NavigationPathBuilder } = MojitoPresentation.Base.Navigation;

/**
 * Sport tab selector types.
 *
 * @class SportTabSelectorTypes
 * @name types
 * @memberof Mojito.Modules.SportTabSelector
 */

/**
 * Tab data item.
 *
 * @typedef TabDataItem
 * @type {object}
 * @property {string} name - Lowercase name.
 * @property {object} analyticsData - Analytics data.
 * @property {Function} routeFn - Function to build navigation object. Typically a Mojito.Presentation.Base.Navigation.NavigationPathBuilder function.
 * @property {string} className - Class name used for testing.
 *
 * @memberof Mojito.Modules.SportTabSelector.types
 */

/**
 * Sport tab selector data.
 * The order of the list decides the order of the tabs shown in the selector.
 *
 * @enum {Array<Mojito.Modules.SportTabSelector.types.TabDataItem>}
 * @memberof Mojito.Modules.SportTabSelector.types
 */
export const TABS = [
    {
        name: 'competitions',
        analyticsData: {
            type: 'matchSportMainNavigationClicked',
            linkName: 'Competitions',
        },
        routeFn: NavigationPathBuilder.toSportCompetitions,
        className: 'ta-competitions',
    },
    {
        name: 'matches',
        analyticsData: {
            type: 'matchSportMainNavigationClicked',
            linkName: 'Matches',
        },
        routeFn: NavigationPathBuilder.toSportMatches,
        className: 'ta-matches',
    },
    {
        name: 'highlights',
        analyticsData: {
            type: 'racingMainNavigationClicked',
            linkName: 'Highlights',
        },
        routeFn: NavigationPathBuilder.toSportHighlights,
        className: 'ta-highlights',
    },
    {
        name: 'meetings',
        analyticsData: {
            type: 'racingMainNavigationClicked',
            linkName: 'Meetings',
        },
        routeFn: NavigationPathBuilder.toSportMeetings,
        className: 'ta-meetings',
    },
    {
        name: 'price_boosts',
        analyticsData: {
            type: 'sportMainNavigationClicked',
            linkName: 'PriceBoosts',
        },
        routeFn: NavigationPathBuilder.toSportPriceBoosts,
        className: 'ta-price-boosts',
    },
    {
        name: 'outrights',
        analyticsData: {
            type: 'sportMainNavigationClicked',
            linkName: 'Outrights',
        },
        routeFn: NavigationPathBuilder.toSportOutright,
        className: 'ta-outrights',
    },
    {
        name: 'future',
        analyticsData: {
            type: 'sportMainNavigationClicked',
            linkName: 'Future',
        },
        routeFn: NavigationPathBuilder.toSportFuture,
        className: 'ta-future',
    },
];
